import { FC } from 'react' // useImperativeHandle, useState, withRefFCを削除
import {
  DropDownList,
  DropDownListChangeEvent
} from '@progress/kendo-react-dropdowns'
import { useAppSelector } from '../../stores'
import './YearSetting.css'
import { Authority } from '../../gateway/system/Authority'

// 親から受け取るpropsの型を定義
export interface YearSettingProps {
  value: string
  onChange: (newYear: string) => void
}

export const YearSetting: FC<YearSettingProps> = ({ value, onChange }) => {
  const userProp = useAppSelector((x) => x.common.userProp)

  // 現在の日付を基に年度を計算（4月始まり）
  const today = new Date()
  const currentYear = today.getFullYear()
  const currentMonth = today.getMonth()
  // 4月(月番号3)より前なら前年度扱い
  const fiscalYear = currentMonth < 3 ? currentYear - 1 : currentYear

  // 年のドロップダウン項目（現在年度の-1年から+4年までの6年間）
  const yearList = Array.from({ length: 6 }).map((_, k) => String(fiscalYear - 1 + k))

  /**
   * 年の変更イベントハンドラ
   */
  const handleSelectYear = (event: DropDownListChangeEvent) => {
    onChange(event.value)
  }

  return (
    <>
      <DropDownList
        style={{ marginBottom: 10, marginLeft: 30, width: '30%' }}
        onChange={handleSelectYear}
        data={yearList}
        value={value} // 親から渡された値を表示
        popupSettings={{ className: 'pcy-dropdownlist' }}
        disabled={userProp?.authority !== Authority.Builder}
      />
    </>
  )
}
